import React from 'react';
import { styled } from '../../../../../../styles';
import { useIntlBds } from '../../../../../../translations/BdsIntlProvider';
import { IconName } from '../../../../../Icon/types';
import { IconButton, IconButtonProps } from '../../../../../IconButton/IconButton';
import { DataTableTypes } from '../../../../DataTableTypes';
import { dataTableClassnames } from '../../../const/classNames';
import { useDataTableContext } from '../../../context/DataTableContext';

interface SortCellProps {
  type: string;
  slotProps?: {
    iconButton?: Omit<IconButtonProps, 'iconName' | 'dataTest' | 'ref'>;
  };
}

export const SortCell: React.FC<SortCellProps> = ({ type, slotProps }) => {
  const { model, state, actions } = useDataTableContext();

  const sortState = getState(type, model.sort);
  const { intl } = useIntlBds();

  return (
    <StyledIconButton
      {...slotProps?.iconButton}
      slotProps={{ tooltip: { title: intl.DataTable.Sort.tooltipText, placement: 'top' } }}
      aria-label={`Sort${!sortState.isSet ? '' : sortState.reversed ? 'Up' : 'Down'}`}
      color={sortState.isSet ? 'active' : undefined}
      iconName={sortState.iconName}
      dataTest={sortState.dataTest}
      disabled={!!state.selectedRows.length}
      onClick={() => {
        actions.setSortChange(type, sortState.isSet, sortState.reversed);
      }}
      $reversed={sortState.reversed}
    />
  );
};

const StyledIconButton = styled(IconButton)<{ $reversed: boolean }>`
    transition: all 0.2s ease-in-out;
    transform: ${({ $reversed }) => ($reversed ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

function getState(
  type: string,
  model: DataTableTypes.SortModelQuery<string>[] | undefined
): DataTableTypes.SortModelQuery<string> & {
  isSet: boolean;
  iconName: IconName;
  dataTest: string;
} {
  const targetSortModel = model?.[0];
  if (!targetSortModel || targetSortModel.type !== type) {
    return {
      isSet: false,
      type: type,
      reversed: false,
      iconName: 'swap_vert',
      dataTest: dataTableClassnames.table.row.sort(type)
    };
  }
  return {
    ...targetSortModel,
    iconName: 'arrow_upward',
    isSet: true,
    dataTest: `${dataTableClassnames.table.row.sort(type)}-${targetSortModel.reversed ? 'down' : 'up'}`
  };
}
